<template>
  <div>
    <form novalidate @submit.prevent="saveData" class="text-left" v-if="customData && customData.length > 0">
      <div v-for="field in working" :key="field.fieldId" class="mt-4">
        <div v-if="helpTextAsLabel && field.helpText" class="help-text">
          <span v-html="field.helpText"></span>
          <mdb-badge v-if="field.currValue.forceReAnswer && isSelf" color="danger">Please Review This Answer</mdb-badge>
        </div>
        <mdb-input :disabled="!editing" v-if="field.fieldType=='SHORT_TEXT'" type="text"
                   :id="'validation' + field.fieldId"
                   :required="field.required"
                   :label="(helpTextAsLabel && field.helpText ? '' : field.fieldName)"
                   invalidFeedback="Field is required."
                   v-model="field.currValue.shortTextValue"/>
        <mdb-input :disabled="!editing" v-if="field.fieldType=='INTEGER'" type="number" :step="1"
                   :required="field.required"
                   :label="(helpTextAsLabel && field.helpText ? '' : field.fieldName)"
                   :id="'validation' + field.fieldId"
                   invalidFeedback="Field is required."
                   v-model="field.currValue.integerValue"/>
        <mdb-input :disabled="!editing" v-if="field.fieldType=='FLOAT'" type="number" :step="0.01"
                   :required="field.required"
                   :id="'validation' + field.fieldId"
                   :label="(helpTextAsLabel && field.helpText ? '' : field.fieldName)"
                   invalidFeedback="Field is required."
                   v-model="field.currValue.floatValue"/>
        <mdb-input :disabled="!editing" v-if="field.fieldType=='LONG_TEXT'"
                   type="textarea" :rows="2"
                   :required="field.required"
                   :label="(helpTextAsLabel && field.helpText ? '' : field.fieldName)"
                   invalidFeedback="Field is required."
                   :id="'validation' + field.fieldId"
                   v-model="field.currValue.longTextValue"/>
        <div v-if="field.fieldType=='BOOLEAN'" class="text-left">
          <mdb-input :disabled="!editing" type="checkbox" :name="'checkbox_'+field.fieldId"
                     :id="'validation' + field.fieldId"
                     :label="(helpTextAsLabel && field.helpText ? ' ' : field.fieldName)"
                     v-model="field.currValue.booleanValue"/>
          <hr/>
        </div>
        <div v-if="field.fieldType=='ACKNOWLEDGEMENT' && isSelf" class="text-left">
          <mdb-input :disabled="!editing" type="checkbox"
                     :required="editing && isSelf"
                     invalidFeedback="Acknowledgement is required."
                     :label="(helpTextAsLabel && field.helpText ? 'Acknowledged' : field.fieldName)"
                     :name="'checkbox_'+field.fieldId"
                     :id="'validation' + field.fieldId"
                     v-model="field.currValue.acknowledged"/>
          <hr/>
        </div>
        <div v-if="field.fieldType=='ACKNOWLEDGEMENT' && !isSelf" class="text-left">
          <div v-if="!(helpTextAsLabel && field.helpText)" class="help-text">{{ field.fieldName }}</div>
          <mdb-badge color="danger" v-if="!field.currValue.acknowledged">Not Acknowledged</mdb-badge>
          <mdb-badge color="success" v-if="field.currValue.acknowledged">Acknowledged</mdb-badge>
          <hr/>
        </div>

        <div v-if="field.fieldType=='PICKLIST'">
          <div class="md-form" v-if="editing">
            <label v-if="!(helpTextAsLabel && field.helpText)" class="active">{{ field.fieldName }}</label>
            <select class="browser-default gp-custom-select"
                    :required="field.required"
                    v-model="field.currValue.pickedValue">
              <option v-for="(opt,i) in field.pickListValues" :key="i" :value="opt">{{ opt }}</option>
            </select>
          </div>
          <mdb-input v-if="!editing" disabled type="text"
                     :required="field.required"
                     :label="(helpTextAsLabel && field.helpText ? '' : field.fieldName)"
                     v-model="field.currValue.pickedValue"/>
        </div>

        <div v-if="field.fieldType=='FILE'" class="text-left">
          <div v-if="field.currValue.hasFile">
            <mdb-icon icon="check" color="success"/>
            File Uploaded {{ field.currValue.fileName }}
          </div>
          <div v-if="!field.currValue.hasFile">
            <mdb-icon icon="times-circle" color="danger"/>
            No File
          </div>
          <mdb-btn v-if="editing" size="sm" icon="upload" @click="newFile(field)">Upload New File</mdb-btn>
          <mdb-btn v-if="field.currValue.hasFile" size="sm" color="secondary" @click="download(field.currValue)"
                   icon="download">Download
          </mdb-btn>
          <hr/>
        </div>

        <div v-if="field.fieldType=='DATE'" class="text-left">
          <div class="md-form" v-if="editing">
            <date-picker
              type="date"
              :format="userDetails.dateFormat.toUpperCase()"
              value-type="date"
              editable
              :clearable="true"
              :lang="lang"
              v-model="field.currValue.dateValue"
              confirm
            />


            <!--datetime v-model="field.currValue.dateValue"
                      :auto="true"
                      :format="userDetails.dateFormat"
                      :valueZone="userDetails.timezone"
                      :week-start="userDetails.mondayFirst ? 1 : 7"
                      :zone="userDetails.timezone"></datetime>
                      -->
            <label v-if="!(helpTextAsLabel && field.helpText)" class="active mr-5">{{ field.fieldName }}</label>
            <!--<a v-if="field.currValue.dateValue" href="" @click.prevent="clearDate(field)" class="badge secondary-color">
              <mdb-icon icon="window-close"/>
              Clear Date
            </a> -->
          </div>
          <mdb-input v-if="!editing" disabled type="text"
                     :label="(helpTextAsLabel && field.helpText ? '' : field.fieldName)"
                     v-model="field.currValue.dateDisplay"/>
        </div>
      </div>

      <div id="custom-data-upload" v-if="showUpload">
        <mdb-file-upload :disabled="uploading" :files="filesToUpload" @change="handleChange"/>
        <mdb-btn color="danger" size="sm" @click="showUpload=false">Cancel Upload</mdb-btn>
      </div>

      <div class="text-left">
        <mdb-btn v-if="allowEdit && !editing" size="sm" rounded icon="pencil" @click="editing=true">Edit</mdb-btn>
        <mdb-btn v-if="editing" type="submit" size="sm" rounded color="success" icon="save">Save</mdb-btn>
        <mdb-btn v-if="editing && !forceEdit" size="sm" rounded color="warning" icon="minus-circle" @click="cancelEdit">
          Cancel
        </mdb-btn>
      </div>
    </form>
    <div v-if="!customData || customData.length == 0" class="text-info small">
      <b>No custom user fields have been defined.</b>
    </div>

  </div>
</template>

<script>
import {mdbBadge, mdbBtn, mdbIcon, mdbInput, mdbModal, mdbModalBody, mdbModalHeader} from 'mdbvue';
import {Datetime} from 'vue-datetime'
import mdbFileUpload from 'mdbvue-file-upload'
import download from "js-file-download";
import api from '../../services/groupsPlaceApi.js'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import 'vue2-datepicker/index.css';

export default {
  name: 'custom-data-viewer-editor',
  components: {
    mdbInput, mdbBtn, mdbIcon, mdbBadge, mdbFileUpload, mdbModal,
    mdbModalBody,
    mdbModalHeader,
    Datetime,
    DatePicker
  },
  props: {
    customData: {
      type: Array,
      default: null
    },
    allowEdit: {
      type: Boolean,
      default: false
    },
    forceEdit: {
      type: Boolean,
      default: false
    },
    isSelf: {
      type: Boolean,
      default: false
    },
    helpTextAsLabel: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (this.userDetails && this.userDetails.firstDayOfWeek == "Monday") this.lang.formatLocale.firstDayOfWeek = 1;
    this.setWorking()
    if (this.forceEdit) this.editing = true
  },
  computed: {
    userDetails() {
      return this.$store.state.userDetails
    }
  },
  data() {
    return {
      working: null,
      editing: false,
      readyToUpload: false,
      uploading: false,
      filesToUpload: [],
      showUpload: false,
      uploadField: null,
      lang: {
        formatLocale: {
          firstDayOfWeek: 0
        }
      }
    }
  },
  methods: {
    setWorking() {
      this.working = JSON.parse(JSON.stringify(this.customData));
      for (let c of this.working) {
        if (c.fieldType == "DATE" && c.currValue.dateValue) {
          c.currValue.dateValue = new Date(c.currValue.dateValue)
        }
      }
    },
    newFile(field) {
      this.uploadField = field
      this.showUpload = true
      this.$nextTick().then(() => {
        let el = document.getElementById("custom-data-upload")
        if (el) window.scrollTo(0, el.offsetTop)
      })

    },
    handleChange(file) {
      if (file && file.length > 0) {
        this.showUpload = false
        this.$store.dispatch("setExecuting", true)
        let url = "/user/newFile"
        this.gotError = false
        api.postFile(url, file[0]).then(
          (results) => {
            this.uploadField.currValue.hasFile = true
            this.uploadField.currValue.fileId = results.data.file.accessCode
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 5000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })

      }
    },
    cancelEdit() {
      this.setWorking()
      this.editing = false
    },
    saveData(event) {
      if (event.target.checkValidity()) {
        if (!this.forceEdit) this.editing = false
        this.$emit("dataSaved", this.working)
        for (let c of this.working) {
          if (c.fieldType == "DATE") {
            if (c.currValue.dateValue) {
              c.currValue.dateDisplay = moment(c.currValue.dateValue).format(this.userDetails.dateFormat.toUpperCase())
            }
            else {
              c.currValue.dateDisplay = ""
            }
          }
        }


      } else {
        event.target.classList.add("was-validated")
      }
    },
    clearDate(field) {
      field.currValue.dateValue = null
    },
    download(currValue) {
      this.$store.dispatch("setExecuting", true)
      api.getBlob("/user/getFile/" + currValue.fileId, {}).then(
        (res) => {
          download(res.data, currValue.fileName)
        },
        (error) => {
          this.$notify.error({message: "Could not retrieve file - " + error.response.status, timeOut: 4000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }

  }


}
;
</script>
<style lang="scss">
@import '~vue-datetime/dist/vue-datetime.min';

.help-text {
  font-size: .9rem;
  font-weight: 300;
  color: #3d799c;
}
</style>
